import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useState } from "preact/hooks";
import { t, translate } from "restaumatic-client";
import RadioField from "./RadioField";
import SelectField from "./SelectField";
import EditBlock from "./EditBlock";
function FulfillmentTimeForm(props) {
    const { fulfillmentTime, controller, onChange } = props;
    const [editClicked, setEditClicked] = useState(false);
    if (!fulfillmentTime.hasAnyOptions) {
        return null;
    }
    const isFormVisible = editClicked ||
        !fulfillmentTime.activeOption ||
        controller.isDirty ||
        controller.isInvalid;
    return (h(Fragment, null,
        isFormVisible && (h(FulfillmentTimeOptions, { fulfillmentTime: fulfillmentTime, controller: controller, onChange: onChange })),
        !isFormVisible && (h(SelectedView, { fulfillmentTime: fulfillmentTime, onEdit: () => setEditClicked(true) }))));
}
/**
 * Contains Radio field with fulfillment time options with sub-options for OnTime and OnDateAndTime
 */
export const FulfillmentTimeOptions = observer((props) => {
    const { fulfillmentTime, controller, onChange } = props;
    const { options } = fulfillmentTime;
    const { fulfillmentOption, fulfillmentDate, fulfillmentHour } = controller.fields;
    const optionsWithChildren = options.map((option) => ({
        value: option.type,
        label: option.label,
        children: getOptionChildren(option, fulfillmentDate, fulfillmentHour, onChange),
    }));
    return (h(RadioField, { name: "fulfillmentTime", dataFieldId: "fulfillmentTime", controller: fulfillmentOption, options: optionsWithChildren, label: translate(t.activerecord.attributes.order.deliver_at), onChange: onChange }));
});
function getOptionChildren(option, dateField, hourField, onChange) {
    switch (option.type) {
        case "ASAP":
            return undefined;
        case "Today":
            return (h(SelectField, { controller: hourField, options: option.timeOptions, name: "order_deliver_at", dataFieldId: "deliverAt", label: translate(t.activerecord.attributes.order.deliver_at), placeholder: translate(t.orders.form.choose_time), hideLabel: true, onChange: onChange }));
        case "InFuture":
            return (h(Fragment, null,
                h(SelectField, { name: "order_deliver_at_date", dataFieldId: "deliverAtDate", controller: dateField, options: option.dateOptions, disabled: option.dateDisabled, label: translate(t.orders.form.choose_date), placeholder: translate(t.orders.form.choose_date), hideLabel: true, onChange: onChange }),
                h(SelectField, { name: "order_deliver_at_time", dataFieldId: "deliverAt", controller: hourField, options: option.timeOptions, disabled: option.timeDisabled, label: translate(t.orders.form.choose_time), placeholder: translate(t.orders.form.choose_time), hideLabel: true, onChange: onChange })));
    }
}
function SelectedView(props) {
    var _a;
    const { fulfillmentTime, onEdit } = props;
    const { isEditable } = fulfillmentTime;
    const label = translate(t.activerecord.attributes.order.deliver_at);
    const title = fulfillmentTime.formattedValue;
    const description = ((_a = fulfillmentTime.activeOption) === null || _a === void 0 ? void 0 : _a.type) === "ASAP"
        ? translate(t.orders.form.asap_description)
        : undefined;
    return (h("div", { class: "form-group" },
        h("label", { class: "m-form__label m-form__label--required" }, label),
        h(EditBlock, { type: "icon", icon: "time", title: title, description: description, ariaLabel: label, onEdit: onEdit, isEditable: isEditable })));
}
export default observer(FulfillmentTimeForm);
